module.exports = require("@vf-dcl/vodafone-ws2");